import { isStreamIQ, isToya } from '../lib'

export const getVODRecommendationHook = async () => {
    if (isToya()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/toya/widgets/profileScreen/hooks/useGetVodRecommendationsTOYA')
            return module.useGetVodRecommendationsTOYA
        } catch (error) {
            console.warn(
                'useGetVodRecommendationsTOYA module is missing.',
                error
            )
        }
    }
    if (isStreamIQ()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/streamiq/features/VOD/hooks/useGetVodRecommendationsStreamIQ')
            return module.useGetVodRecommendationsStreamIQ
        } catch (error) {
            console.warn(
                'useGetVodRecommendationsStreamIQ module is missing.',
                error
            )
        }
    }
    throw new Error('Unknown API type')
}
